export const buttonStates = ['default', 'hover', 'disabled', 'loading', 'overflow'] as const;
export const buttonVariants = [
  'default',
  'secondary',
  'destructive',
  'outline',
  'secondary-outline',
  'destructive-outline',
] as const;
export const buttonSizes = ['max', 'lg', 'md', 'sm', 'xs', 'icon', 'icon-xs'] as const;

export const inputStates = ['default', 'error', 'disabled'] as const;
export const inputSizes = ['lg', 'md', 'sm'] as const;

export const passwordInputVariants = ['default', 'with-strength'] as const;
export const textareaStates = ['default', 'error', 'disabled'] as const;

export const selectStates = ['default', 'disabled'] as const;

export const alertStates = ['info', 'success', 'warning', 'error'] as const;
export const badgeStates = ['success', 'warning', 'error', 'info'] as const;
export const avatarStates = ['image', 'initials', 'fallback'] as const;

export const checkboxStates = ['unchecked', 'checked', 'disabled'] as const;
export const radioStates = ['option-1', 'option-2', 'disabled'] as const;
export const switchStates = ['off', 'on', 'disabled'] as const;

export const tabStates = ['account', 'security', 'billing'] as const;

export const tooltipStates = ['default', 'long'] as const;

export const progressStates = [0, 35, 70, 100] as const;

export const spinnerSizes = ['sm', 'md', 'lg'] as const;
